import { setting } from "shared/types/Report";
import { SettingCard, SettingTitle, SettingGroupWrap, SettingGroup, SettingLabelWrap, SettingLabel, SettingCheck, SettingSelect } from "../homeworkUi";

interface VideoSettingProps{
    viewOptions:(name:string, max:number, unit:string) => any[],
    onSettingChangeHandler: <T>(type: keyof setting, name: string, value: T) => void,
    setting:setting
}

const VideoSetting = ({viewOptions, onSettingChangeHandler, setting}:VideoSettingProps) => {
    const TYPE = "video";

    return(
        <SettingCard>
            <SettingTitle>영상 학습</SettingTitle>
            <SettingGroupWrap>
                <SettingGroup>
                    <SettingLabelWrap>
                        <SettingCheck type="checkbox" id="video" name="video" checked={setting.video.video} onChange={(e) => onSettingChangeHandler(TYPE, e.target.name, e.target.checked)}/>
                        <SettingLabel htmlFor="video">녹음 하기</SettingLabel>
                    </SettingLabelWrap>
                    <SettingSelect name="video_repeat" value={setting.video.video_repeat} onChange={(e) => onSettingChangeHandler(TYPE, e.target.name, parseInt(e.target.value))} disabled={!setting.video.video}>
                        {viewOptions("녹음 동영상 보기", 4, "번")}
                    </SettingSelect>
                </SettingGroup>
            </SettingGroupWrap>
        </SettingCard>
    )
}

export default VideoSetting;
